import React, { createContext, useContext, useState } from 'react'

import PolicyContainer from '@legacy/models/PolicyContainer'

export type SetPolicyCallback = React.Dispatch<React.SetStateAction<PolicyContainer | null>>

type ContextType = {
  activePolicyContainer: PolicyContainer | null
  setActivePolicyContainer: SetPolicyCallback
}

type ProviderProps = {
  initialPolicyContainer: PolicyContainer | null
  children: React.ReactNode
}

const ActivePolicyContainerContext = createContext<ContextType | undefined>(undefined)

function useActivePolicyContainer() {
  const context = useContext(ActivePolicyContainerContext)
  if (!context) {
    throw new Error(`useActivePolicyContainer must be used within an ActivePolicyContainerProvider`)
  }
  return context
}

const ActivePolicyContainerProvider = ({ initialPolicyContainer, children }: ProviderProps) => {
  const [activePolicyContainer, setActivePolicyContainer] = useState<PolicyContainer | null>(initialPolicyContainer)
  const value: ContextType = { activePolicyContainer, setActivePolicyContainer }

  return <ActivePolicyContainerContext.Provider value={value}>{children}</ActivePolicyContainerContext.Provider>
}

export { ActivePolicyContainerProvider, useActivePolicyContainer }
